import Layout from '../layout.vue'
import List from './list.vue'
import Editor from './editor.vue'
import Send from './send.vue'

const basePath = '/v-admin/crm-management/campaign-management'

export default {
  path: `${basePath}/list`,
  component: Layout,
  meta: {
    permission: ['PERM_MICROSITE_CAMPAIGN_MANAGEMANT', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'],
    titleI18nKey: 'admin.crm.title.campaign.list',
    menu: {
      labelI18nKey: 'admin.crm.menu.campaign'
    }
  },
  children: [
    {
      name: 'crmCampaignList',
      path: '',
      component: List,
      meta: {
        titleI18nKey: 'admin.crm.title.campaign.list',
        breadcrumb: { hidden: true }
      }
    },
    {
      name: 'addCrmCampaign',
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        titleI18nKey: 'admin.crm.title.campaign.add'
      }
    },
    {
      name: 'editCrmCampaign',
      path: `${basePath}/edit/:campaignId`,
      component: Editor,
      meta: {
        titleI18nKey: 'admin.crm.title.campaign.edit',
        isEditMode: true
      }
    },
    {
      name: 'sendCrmCampaign',
      path: `${basePath}/send/:campaignId`,
      component: Send,
      meta: {
        titleI18nKey: 'admin.crm.title.campaign.send'
      }
    }
  ]

}
